<template>
    <!-- 诗词详情页面 -->
    <div class="poem-detail">
        <!-- 正文内容 -->
        <Content :poem="poem" :poet="poet" :tags="tags"/>

        <!-- 注释等信息 -->
        <Info :poem="poem"/>
    </div>
</template>

<script>
    import {GetPoemById} from "@/request/poem";
    import Content from './children/Content';
    import Info from './children/Info';
    import {GetPoetById} from "@/request/poet";
    import {GetTagsByPoemId} from "@/request/poem";

    export default {
        name: "PoemDetail",
        created() {
            // TODO 1. 指定导航栏类型
            this.$store.commit("nav/typeUpdate",2);
            // TODO 2. 获取路由参数
            this.id = this.$route.params.id;
            // TODO 3. 获取诗词信息
            GetPoemById({
                id:this.id
            }).then(res => {
                if (res.code === 200){
                    this.poem = res.data.poem;
                }
            }).then(() => {
                // TODO 4. 获取诗人信息
                GetPoetById({
                    id:this.poem.poetId
                }).then(res => {
                    this.poet = res.data.poet;
                });
                // TODO 5. 获取标签信息
                GetTagsByPoemId({
                    poemId:this.poem.id
                }).then(res => {
                    if (res.code === 200){
                        this.tags = res.data.list;
                    }
                })
            })
        },
        data(){
            return{
                id:"",
                poem:{
                    title:"",
                    content:"",
                    appreciation:"",
                    translation:"",
                    notes:"",
                    background:""
                },
                // 诗人信息
                poet:{
                    name:"",
                    dynasty:""
                },
                // 标签信息
                tags:[]
            }
        },
        components:{
            Content,
            Info
        }
    }
</script>

<style scoped lang="less">
    .poem-detail{
        margin-top: 103px;
    }
</style>